/*
sai krishna 01/19/2023 2698197526  initial tab renders
Ashraf 01/25/2023 2698197526 Added tab rejected
Akhila 03/06/2023 2698197526 Added assigned and owned Form
Sohel 03/06/2023 2698197526 Fixed New Business route issue
Sohel 03/08/2023 2698197526 hide undo batch functionality
*/

import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Owned from './Owned';
import Assigned from './Assigned';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function EnableFrameworkTabs({value, setValue, newBusinessAccess}) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {value === 0 && <Assigned value={value} newBusinessAccess={newBusinessAccess} />}
        {value === 1 && (
          <Owned
            value={value}
            setValue={setValue}
            hideActions={true}
            newBusinessAccess={newBusinessAccess}
          />
        )}
        {value === 2 && (
          <Owned
            value={value}
            setValue={setValue}
            hideActions={false}
            newBusinessAccess={newBusinessAccess}
          />
        )}
      </div>
    </div>
  );
}
